// extracted by mini-css-extract-plugin
module.exports = {"form":"change-auth_form__2wAwv","block":"change-auth_block__12dCF","input":"change-auth_input__1yXvk","button":"change-auth_button__30O01"};